module.exports = __webpack_public_path__ + "img/no_image.8a94fbca.png";